// @ts-strict

import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@env/environment';
import { BehaviorSubject, Observable } from 'rxjs';
import { BaseApiResponse, PageableApiResponse } from '../..';
import { NotificationsResponseData } from './notifications.service.types';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {
  public unread$ = new BehaviorSubject<null | number>(null);

  constructor(private readonly http: HttpClient) {}

  public getNotificationsData(page: number): Observable<PageableApiResponse<NotificationsResponseData>> {
    const url = `${environment.apiUrl}/notifications/list`;

    return this.http
      .get<PageableApiResponse<NotificationsResponseData>>(url, {
        params: { page: page.toString() }
      })
      .pipe(
        tap(res => {
          const unreadCount = res.data?.information?.unread ?? null;
          this.unread$.next(unreadCount);
        })
      );
  }

  public markNotificationAsRead(id: any): Observable<BaseApiResponse<{ message?: string }>> {
    const reqBody = { status: 2 };
    return this.http.put<BaseApiResponse<{ message?: string }>>(environment.apiUrl + `/notifications/${id}/update_status`, reqBody);
  }

  public markAllNotificationsAsRead(): Observable<BaseApiResponse<{ message?: string }>> {
    this.unread$.next(null);
    return this.http.put<BaseApiResponse<{ message?: string }>>(environment.apiUrl + `/notifications/all/read`, '');
  }
}
